<template>
  <div class="widget__wrapper">
    <div
      class="widget"
      :style="{ bottom: `${position.y}px`, right: `${position.x}px` }"
      @mousedown="startDrag"
      @mouseup="stopDrag"
      @mousemove="onDrag"
      @click="callManager"
    >
      <SvgIcon icon="user" />
      <span v-show="!isMobile">Позвать на помощь менеджера</span>
    </div>
    <Teleport to="body">
      <AppPopup
        :isOpen="isConfirmPopupOpen"
        title="Заявка отправлена "
        hiddenClose
        class="widget__popup"
        @close="onConfirmPopupClose"
      >
        <div class="widget__popup-body">
          <span class="widget__popup-text">Заявка отправлена и в ближайшее время с вами свяжется менеджер</span>
          <button class="widget__popup-button" @click="onConfirmPopupClose">
            Спасибо
          </button>
        </div>
      </AppPopup>
    </Teleport>
  </div>
</template>

<script lang="ts" src="./CallWidget.ts"></script>

<style lang="scss" scoped src="./CallWidget.scss"></style>
